import { z } from 'zod';

import { IsoDateSchema } from './common.js';

export const StatsWindowSchema = z.enum(['4w', '12w', '26w', '52w']);
export type StatsWindow = z.infer<typeof StatsWindowSchema>;

export const WeeklyVolumeSchema = z.object({
  weekStart: IsoDateSchema, // Monday 00:00 UTC of the week
  totalVolume: z.number(),
  workouts: z.number().int(),
});
export type WeeklyVolume = z.infer<typeof WeeklyVolumeSchema>;

export const VolumeResponseSchema = z.object({
  window: StatsWindowSchema,
  points: z.array(WeeklyVolumeSchema),
});
export type VolumeResponse = z.infer<typeof VolumeResponseSchema>;

export const FrequencyResponseSchema = z.object({
  window: StatsWindowSchema,
  points: z.array(
    z.object({
      weekStart: IsoDateSchema,
      workouts: z.number().int(),
    }),
  ),
  weeklyGoal: z.number().int(),
});
export type FrequencyResponse = z.infer<typeof FrequencyResponseSchema>;

export const PersonalRecordSchema = z.object({
  exerciseId: z.string(),
  exerciseName: z.string().nullable(),
  bestWeight: z.number(),
  bestReps: z.number().int(),
  estimatedOneRepMax: z.number(),
  achievedAt: IsoDateSchema,
  workoutId: z.string(),
});
export type PersonalRecord = z.infer<typeof PersonalRecordSchema>;

export const PersonalRecordsResponseSchema = z.object({
  items: z.array(PersonalRecordSchema),
});
export type PersonalRecordsResponse = z.infer<typeof PersonalRecordsResponseSchema>;
